// @flow
import client from '../../client'
import { config } from '../../config'
import prebookReservationBuilder from './builders/prebook'
import ondemandReservationBuilder from './builders/ondemand'
import format from '../../utils/format'

// Types
import type { Reservation } from '../../models/reservation'
import type { PrebookReservation, OndemandReservation } from '../../api_types'

export type Options = {
  id: string,
  ondemand: boolean,
}

// Constants
export const RESERVATION_ENDPOINT = '/reservations/{0}/'
export const ONDEMAND_RESERVATION_ENDPOINT = '/ondemand/reservations/{0}/'

/**
 * Returns a Reservation by its iD
 * @param {Object} data Reservation information
 * @param {string} data.id Reservation ID
 * @return {Promise|Error} A resolved Promise with the reservation or an empty array or Rejected with an Error
 */
export const get = (data: Options): Promise<Reservation> => {
  const rawEndpoint = data.ondemand
    ? ONDEMAND_RESERVATION_ENDPOINT
    : RESERVATION_ENDPOINT
  const endpoint = format(rawEndpoint, data.id)

  return client
    .get(format(endpoint), { baseUrl: config.BASE_URL_RESERVATIONS })
    .then((response) =>
      data.ondemand
        ? ondemandReservationBuilder((response: OndemandReservation))
        : prebookReservationBuilder((response: PrebookReservation))
    )
}

export default get
